/** Mirrors backend `HowToGuidePayload` (backend/src/ai-agent/help/guide.types.ts). */
export interface HowToStep {
  index: number;
  title: string;
  detail: string;
  route?: string;
  routeLabel?: string;
  permission?: string;
  missingPermission?: string;
  routeBlocked?: boolean;
  fields?: string[];
  tip?: string;
}

export interface HowToCompanyNote {
  memoryId: string;
  title: string;
  summary: string;
  detail?: string | null;
  author?: string | null;
  publishedAt?: string | null;
}

export interface HowToGuidePayload {
  guideId: string;
  module: string;
  moduleLabel: string;
  title: string;
  summary: string;
  kind: 'task' | 'workflow' | 'concept' | 'troubleshoot';
  source: 'guide' | 'general';
  prerequisites: string[];
  steps: HowToStep[];
  workflowStages: string[];
  troubleshooting: Array<{ symptom: string; cause: string; fix: string }>;
  companyNotes: HowToCompanyNote[];
  related: Array<{ id: string; title: string }>;
  reports: Array<{ label: string; path: string }>;
  approvalConfigured?: boolean;
  exampleNumber?: string | null;
  documentLabel?: string | null;
  missingPermissions: string[];
  packUnavailable?: boolean;
}

export interface HelpGuideListItem {
  id: string;
  title: string;
  summary: string;
  module: string;
  moduleLabel: string;
  kind: HowToGuidePayload['kind'];
  stepCount: number;
}

export function isHowToGuidePayload(v: unknown): v is HowToGuidePayload {
  if (!v || typeof v !== 'object') return false;
  const o = v as Record<string, unknown>;
  return typeof o.guideId === 'string' && Array.isArray(o.steps);
}
